import { CategoriesHomePage } from './CategoriesHomePage';

export const HomePage = () => {
  return <CategoriesHomePage />;
};
